var description_default = {
  "subtitle": "A63Af",
  "descriptionItem": "BQWE6"
};
export {
  description_default as default
};
//# sourceMappingURL=description-scss.js.map
